"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CoordinateList = _interopRequireDefault(require("../../geom/CoordinateList"));

var _WKTWriter = _interopRequireDefault(require("../../io/WKTWriter"));

var _CoordinateArraySequence = _interopRequireDefault(require("../../geom/impl/CoordinateArraySequence"));

var _PointLocation = _interopRequireDefault(require("../../algorithm/PointLocation"));

var _LinearRing = _interopRequireDefault(require("../../geom/LinearRing"));

var _Exception = _interopRequireDefault(require("../../../../../java/lang/Exception"));

var _Orientation = _interopRequireDefault(require("../../algorithm/Orientation"));

var _System = _interopRequireDefault(require("../../../../../java/lang/System"));

var _CoordinateArrays = _interopRequireDefault(require("../../geom/CoordinateArrays"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Comparator = _interopRequireDefault(require("../../../../../java/util/Comparator"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EdgeRing =
/*#__PURE__*/
function () {
  function EdgeRing() {
    _classCallCheck(this, EdgeRing);

    EdgeRing.constructor_.apply(this, arguments);
  }

  _createClass(EdgeRing, [{
    key: "isIncluded",
    value: function isIncluded() {
      return this._isIncluded;
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      if (this._ringPts === null) {
        var coordList = new _CoordinateList.default();

        for (var i = this._deList.iterator(); i.hasNext();) {
          var de = i.next();
          var edge = de.getEdge();
          EdgeRing.addEdge(edge.getLine().getCoordinates(), de.getEdgeDirection(), coordList);
        }

        this._ringPts = coordList.toCoordinateArray();
      }

      return this._ringPts;
    }
  }, {
    key: "isIncludedSet",
    value: function isIncludedSet() {
      return this._isIncludedSet;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      this.getCoordinates();
      if (this._ringPts.length <= 3) return false;
      this.getRing();
      return this._ring.isValid();
    }
  }, {
    key: "build",
    value: function build(startDE) {
      var de = startDE;

      do {
        this.add(de);
        de.setRing(this);
        de = de.getNext();

        _Assert.default.isTrue(de !== null, "found null DE in ring");

        _Assert.default.isTrue(de === startDE || !de.isInRing(), "found DE already in ring");
      } while (de !== startDE);
    }
  }, {
    key: "isOuterHole",
    value: function isOuterHole() {
      if (!this._isHole) return false;
      return !this.hasShell();
    }
  }, {
    key: "getPolygon",
    value: function getPolygon() {
      var holeLR = null;

      if (this._holes !== null) {
        holeLR = new Array(this._holes.size()).fill(null);

        for (var i = 0; i < this._holes.size(); i++) {
          holeLR[i] = this._holes.get(i);
        }
      }

      var poly = this._factory.createPolygon(this._ring, holeLR);

      return poly;
    }
  }, {
    key: "isHole",
    value: function isHole() {
      return this._isHole;
    }
  }, {
    key: "isProcessed",
    value: function isProcessed() {
      return this._isProcessed;
    }
  }, {
    key: "addHole",
    value: function addHole() {
      if (arguments[0] instanceof _LinearRing.default) {
        var _hole = arguments[0];
        if (this._holes === null) this._holes = new _ArrayList.default();

        this._holes.add(_hole);
      } else if (arguments[0] instanceof EdgeRing) {
        var holeER = arguments[0];
        holeER.setShell(this);
        var hole = holeER.getRing();
        if (this._holes === null) this._holes = new _ArrayList.default();

        this._holes.add(hole);
      }
    }
  }, {
    key: "setIncluded",
    value: function setIncluded(isIncluded) {
      this._isIncluded = isIncluded;
      this._isIncludedSet = true;
    }
  }, {
    key: "getOuterHole",
    value: function getOuterHole() {
      if (this.isHole()) return null;

      for (var i = 0; i < this._deList.size(); i++) {
        var de = this._deList.get(i);

        var adjRing = de.getSym().getRing();
        if (adjRing.isOuterHole()) return adjRing;
      }

      return null;
    }
  }, {
    key: "computeHole",
    value: function computeHole() {
      var ring = this.getRing();
      this._isHole = _Orientation.default.isCCW(ring.getCoordinates());
    }
  }, {
    key: "hasShell",
    value: function hasShell() {
      return this._shell !== null;
    }
  }, {
    key: "isOuterShell",
    value: function isOuterShell() {
      return this.getOuterHole() !== null;
    }
  }, {
    key: "getLineString",
    value: function getLineString() {
      this.getCoordinates();
      return this._factory.createLineString(this._ringPts);
    }
  }, {
    key: "toString",
    value: function toString() {
      return _WKTWriter.default.toLineString(new _CoordinateArraySequence.default(this.getCoordinates()));
    }
  }, {
    key: "getShell",
    value: function getShell() {
      if (this.isHole()) return this._shell;
      return this;
    }
  }, {
    key: "add",
    value: function add(de) {
      this._deList.add(de);
    }
  }, {
    key: "getRing",
    value: function getRing() {
      if (this._ring !== null) return this._ring;
      this.getCoordinates();
      if (this._ringPts.length < 3) _System.default.out.println(this._ringPts);

      try {
        this._ring = this._factory.createLinearRing(this._ringPts);
      } catch (ex) {
        if (ex instanceof _Exception.default) {
          _System.default.out.println(this._ringPts);
        } else throw ex;
      } finally {}

      return this._ring;
    }
  }, {
    key: "updateIncluded",
    value: function updateIncluded() {
      if (this.isHole()) return null;

      for (var i = 0; i < this._deList.size(); i++) {
        var de = this._deList.get(i);

        var adjShell = de.getSym().getRing().getShell();

        if (adjShell !== null && adjShell.isIncludedSet()) {
          this.setIncluded(!adjShell.isIncluded());
          return null;
        }
      }
    }
  }, {
    key: "setShell",
    value: function setShell(shell) {
      this._shell = shell;
    }
  }, {
    key: "setProcessed",
    value: function setProcessed(isProcessed) {
      this._isProcessed = isProcessed;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeRing;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "findDirEdgesInRing",
    value: function findDirEdgesInRing(startDE) {
      var de = startDE;
      var edges = new _ArrayList.default();

      do {
        edges.add(de);
        de = de.getNext();

        _Assert.default.isTrue(de !== null, "found null DE in ring");

        _Assert.default.isTrue(de === startDE || !de.isInRing(), "found DE already in ring");
      } while (de !== startDE);

      return edges;
    }
  }, {
    key: "addEdge",
    value: function addEdge(coords, isForward, coordList) {
      if (isForward) {
        for (var i = 0; i < coords.length; i++) {
          coordList.add(coords[i], false);
        }
      } else {
        for (var i = coords.length - 1; i >= 0; i--) {
          coordList.add(coords[i], false);
        }
      }
    }
  }, {
    key: "findEdgeRingContaining",
    value: function findEdgeRingContaining(testEr, shellList) {
      var testRing = testEr.getRing();
      var testEnv = testRing.getEnvelopeInternal();
      var testPt = testRing.getCoordinateN(0);
      var minShell = null;
      var minShellEnv = null;

      for (var it = shellList.iterator(); it.hasNext();) {
        var tryShell = it.next();
        var tryShellRing = tryShell.getRing();
        var tryShellEnv = tryShellRing.getEnvelopeInternal();
        if (tryShellEnv.equals(testEnv)) continue;
        if (!tryShellEnv.contains(testEnv)) continue;
        testPt = _CoordinateArrays.default.ptNotInList(testRing.getCoordinates(), tryShellRing.getCoordinates());
        var isContained = false;
        if (_PointLocation.default.isInRing(testPt, tryShellRing.getCoordinates())) isContained = true;

        if (isContained) {
          if (minShell === null || minShellEnv.contains(tryShellEnv)) {
            minShell = tryShell;
            minShellEnv = minShell.getRing().getEnvelopeInternal();
          }
        }
      }

      return minShell;
    }
  }]);

  return EdgeRing;
}();

exports.default = EdgeRing;

var EnvelopeComparator =
/*#__PURE__*/
function () {
  function EnvelopeComparator() {
    _classCallCheck(this, EnvelopeComparator);

    EnvelopeComparator.constructor_.apply(this, arguments);
  }

  _createClass(EnvelopeComparator, [{
    key: "compare",
    value: function compare(obj0, obj1) {
      var r0 = obj0;
      var r1 = obj1;
      return r0.getRing().getEnvelope().compareTo(r1.getRing().getEnvelope());
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EnvelopeComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparator.default];
    }
  }]);

  return EnvelopeComparator;
}();

EnvelopeComparator.constructor_ = function () {};

EdgeRing.EnvelopeComparator = EnvelopeComparator;

EdgeRing.constructor_ = function () {
  this._factory = null;
  this._deList = new _ArrayList.default();
  this._lowestEdge = null;
  this._ring = null;
  this._ringPts = null;
  this._holes = null;
  this._shell = null;
  this._isHole = null;
  this._isProcessed = false;
  this._isIncludedSet = false;
  this._isIncluded = false;
  var factory = arguments[0];
  this._factory = factory;
};